import { i18n } from '@/i18n';
import { isTaskCompleted } from '@/store/task';
import { TaskItem, TaskStatus } from '@/types/task';
import {  TaskInfo } from '@tencent/wphk-act-base-cgi';
import { amount } from '@tencent/wphk-base-utils';
import { computed } from '@vue/composition-api';
import Decimal from 'decimal.js';

type MultiQualTaskInfo = Pick<TaskInfo, 'requiredCount'|'requiredType'|'totalCnt'> & Pick<TaskItem, 'status'>;

export const useMultiAmountTask = (multiQualTaskInfo: MultiQualTaskInfo) => {
  const formatAmount = (amountCnt: number) => amount.fen2Yuan(String(amountCnt));
  const needCount = computed(() => {
    const { requiredCount, totalCnt } = multiQualTaskInfo;
    return formatAmount(new Decimal(requiredCount).minus(totalCnt)
      .toNumber());
  });
  const tipsDesc = computed(() => ({
    descTotal: i18n('已消費HK$totalCnt，', {  totalCnt: formatAmount(multiQualTaskInfo.totalCnt) }),
    descNeedCount: i18n('再消費HK$needCount，可獲贈', { needCount: needCount.value }),
  }));
  const isShowTips = computed(() => {
    const { requiredCount, totalCnt, status } = multiQualTaskInfo;
    // 任务状态为进行中才展示气泡
    const isTaskInProgress = status === TaskStatus.inProgress;
    // 至少累计一次任务金额时才展示气泡(已支付金额不为0)
    const isTaskHalfDone = totalCnt > 0;
    const isTaskDone = isTaskCompleted({ requiredCount, totalCnt });
    return isTaskInProgress && isTaskHalfDone && !isTaskDone;
  });
  return {
    tipsDesc,
    isShowTips,
  };
};
